import Checkbox from '@mui/material/Checkbox'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const RoundCheckboxWrapper = styled('span')`
  width: 35px;
  height: 35px;
  border: 1px solid #c1c1c1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  overflow: hidden;
`

export const StyledCheckbox = styled(Checkbox)`
  &.MuiCheckbox-root {
    padding: 0;
  }
  &.MuiCheckbox-root .MuiSvgIcon-root {
    color: ${colors.white};
    background-color: ${colors.white};
    height: 35px;
    width: 35px;
    margin: -1px;
  }
  &.MuiCheckbox-root.Mui-checked .MuiSvgIcon-root {
    color: #f2f2f2;
    background-color: ${colors.black};
    height: 41px;
    width: 41px;
    margin: -4px;
  }
`
